<script setup>
import { computed } from 'vue'
import { CAMPAIGN_CONFIG } from '../../config.js'

const { copy } = CAMPAIGN_CONFIG

const props = defineProps({
  timeRemaining: {
    type: Number,
    required: true,
  },
  startCountdownAt: {
    type: Number,
    required: true,
  },
})

const widthPercent = computed(() => {
  return Math.max(0, Math.min(100, (props.timeRemaining / props.startCountdownAt) * 100))
})
</script>

<template>
  <div class="relative z-10 text-center">
    <div class="space-y-2 pt-6">
      <div class="bg-brand-grey-light rounded-full w-full h-3">
        <div
          class="bg-brand-primary h-full rounded-full transition-all duration-1000 ease-linear"
          :style="{ width: widthPercent + '%' }"
        />
      </div>
      {{ copy.countdownPrefix }} <span class="font-bold">{{ timeRemaining }}</span>
      {{ timeRemaining > 1 ? copy.countdownSeconds : copy.countdownSecond }}
    </div>
  </div>
</template>
